module.exports = __webpack_public_path__ + "img/iphone_x2.c06f338e.png";